// InvoiceStatus.js
import React from 'react';
import {
  Box,
  Typography
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Schedule as ScheduleIcon,
  Cancel as CancelIcon,
  Error as ErrorIcon,
  Refresh as RefreshIcon,
  Help as HelpIcon
} from '@mui/icons-material';

const InvoiceStatus = ({ 
  status, 
  status_verbose, 
  size = 'small',
  showIcon = true,
  sx = {}
}) => {
  // Invoice status configuration with icons and colors (based on backend INVOICE_STATUS_CHOICES)
  const statusConfig = {
    // Status codes
    'UP': {
      label: 'Unpaid',
      color: 'warning',
      icon: WarningIcon
    },
    'PD': {
      label: 'Paid',
      color: 'success',
      icon: CheckCircleIcon
    },
    'PP': {
      label: 'Partially Paid',
      color: 'info',
      icon: ScheduleIcon
    },
    'OV': {
      label: 'Overdue',
      color: 'error',
      icon: ErrorIcon
    },
    'RP': {
      label: 'Refunded',
      color: 'info',
      icon: RefreshIcon
    },
    'CN': {
      label: 'Cancelled',
      color: 'error',
      icon: CancelIcon
    },
    // Verbose status names (from backend response)
    'Paid': {
      label: 'Paid',
      color: 'success',
      icon: CheckCircleIcon
    },
    'Unpaid': {
      label: 'Unpaid',
      color: 'warning',
      icon: WarningIcon
    },
    'Partially Paid': {
      label: 'Partially Paid',
      color: 'info',
      icon: ScheduleIcon
    },
    'Overdue': {
      label: 'Overdue',
      color: 'error',
      icon: ErrorIcon
    },
    'Refunded': {
      label: 'Refunded',
      color: 'info',
      icon: RefreshIcon
    },
    'Cancelled': {
      label: 'Cancelled',
      color: 'error',
      icon: CancelIcon
    }
  };

  // Prioritize status_verbose if available, otherwise use status
  const statusKey = status_verbose || status;
  const config = statusConfig[statusKey] || {
    label: status_verbose || status || 'Unknown',
    color: 'default',
    icon: HelpIcon
  };

  const IconComponent = config.icon;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ...sx }}>
      {showIcon && (
        <IconComponent 
          sx={{ 
            fontSize: size === 'small' ? '1rem' : '1.25rem',
            color: config.color === 'default' ? 'text.secondary' : `${config.color}.main`
          }} 
        />
      )}
      <Typography 
        variant={size === 'small' ? 'body2' : 'body1'}
        sx={{ 
          fontWeight: 600,
          textTransform: 'uppercase',
          fontSize: size === 'small' ? '0.75rem' : '0.875rem',
          color: config.color === 'default' ? 'text.secondary' : `${config.color}.main`
        }}
      >
        {config.label}
      </Typography>
    </Box>
  );
};

export default InvoiceStatus; 